import Vue from 'vue'
import App from './app'
import { loadProgressBar } from 'axios-progress-bar'
import Notifications from 'vue-notification'
import 'axios-progress-bar/dist/nprogress.css'
import Application from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import VueTimeago from 'vue-timeago'
import jsPDF from 'jspdf'
import Vuelidate from 'vuelidate'
import _ from 'lodash'
// eslint-disable-next-line import/no-duplicates
import * as VueGoogleMaps from 'vue2-google-maps'

import VueUpload from '@websanova/vue-upload'
import FullCalendar from 'vue-full-calendar'

Object.defineProperty(Vue.prototype, '$_', { value: _ })

Vue.use(VueUpload)
Vue.use(Vuelidate)

Vue.use(Notifications)

Vue.use(jsPDF)
Vue.router = router
// Vue.store = store

// GoogleMaps plugin
Vue.use(VueGoogleMaps, {
  load: {
    key: App.googleMapsKey,
    libraries: 'places'
  },
  installComponents: true
})

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  fetchData: { url: 'auth', method: 'GET', enabled: true },
  registerData: {
    url: 'auth/signUp',
    method: 'POST',
    staySignedIn: true,
    autoLogin: true,
    fetchUser: true,
    rememberMe: true,
    redirect: { name: 'dashboard' }
  },
  loginData: {
    url: 'auth/signIn',
    method: 'POST',
    redirect: { name: 'dashboard' },
    fetchUser: true
  },
  logoutData: {
    url: 'auth/signOut',
    method: 'POST',
    redirect: { name: 'signIn' },
    makeRequest: true
  },
  refreshData: {
    url: 'auth/refresh',
    method: 'GET',
    enabled: false,
    interval: 0
  },
  authRedirect: { path: 'auth/signIn' }
})
require('vuetify/dist/vuetify.min.css')
Vue.use(Vuetify, {
  theme: {
    primary: App.primaryColor,
    secondary: '#424242',
    accent: App.accentColor,
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})
Vue.use(FullCalendar)
Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    // 'en-US': require('vue-timeago/locales/en-US.json')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  // provide the router using the "router" option.
  // this will inject the router instance to all child components.
  router,
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store,
  http: {
    emulateJSON: true,
    emulateHTTP: true
  },
  template: '<Application></Application>',
  components: { Application },
  data() {
    return {
      test: 'This is a test in the app'
    }
  },
  mounted() {
    loadProgressBar()
  }
})



// WEBPACK FOOTER //
// ./src/main.js